
import { Vue, Component, Prop } from 'vue-property-decorator';
import * as OrderService from "@/services/merchantSpace/OrderService";

@Component({
  components: {},
})
export default class OrdersNumber extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  readonly offerId!: number;

  @Prop({
    type: Number,
    required: true,
  })
  readonly platformId!: number;

  ordersNumber: number = 0;

  get isDisplayed(): boolean {
    const minOrdersNumber = 10;
    return this.ordersNumber >= minOrdersNumber;
  }

  async created() {
    this.ordersNumber = Number(await OrderService.getOrdersCount(this.offerId, this.platformId)) || 0;
  }
}
